import { Purchases } from "@revenuecat/purchases-js";
import moment from "moment";
import { REVENUECAT_BILLING_PUBLIC_API_KEY } from "../commom/UrlConstant";
import store from "../Redux/store";
import { openDialog } from "../Redux/dialogSlice";
import ShareSellDownIcon from '../components/common/SvgIcons/ShareSellDownIcon';
import BankIcon from '../components/common/SvgIcons/BankIcon';
import VisaIcon from '../components/common/SvgIcons/VisaIcon';
import MastercardIcon from '../components/common/SvgIcons/MastercardIcon';
import WalletIcon from "../commom/Assets/images/wallet.png";
import { Box, Typography } from "@mui/material";

export type DateFormat =
  | 'SHORT_MONTH'      // Dec 17, 2025
  | 'LONG_MONTH'       // December 17, 2025
  | 'MM/DD/YYYY'       // 12/17/2025
  | 'DD/MM/YYYY'       // 17/12/2025
  | 'YYYY-MM-DD'       // 2025-12-17 (ISO)
  | 'ISO'              // 2025-12-17 (alias)
  | 'FULL'             // December 17, 2025 10:30:45 AM
  | 'DATETIME_SHORT'   // Dec 17, 2025 10:30 AM
  | 'DATETIME_LONG';   // December 17, 2025 10:30:45 AM

export interface FormattedDateTime {
  date: string;
  time: string;
  timezone: string;
  full: string;
  iso: string;
}


export const isAuthenticated = () => {
  const user = localStorage.getItem("user");
  return user ? true : false;
};

export const getUserFromLocalStorage = () => {
  const userJson = localStorage.getItem("user");
  return userJson ? JSON.parse(userJson) : null;
};

export const setUserInLocalStorage = (user: any) => {
  localStorage.setItem("user", JSON.stringify(user));
  try {
    window.dispatchEvent(new CustomEvent('user-updated'));
  } catch (e) {
    // no-op in non-browser contexts
  }
};

export const getCurrentUserId = () => {
  const userJson = localStorage.getItem("user");
  return userJson ? JSON.parse(userJson)._id : null;
};

export const currencyFormate = (value: any) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value || 0);
};

export function throttle(callback: any, delay = 1000) {
  let shouldWait = false;

  return (...args: any) => {
    if (shouldWait) return;
    callback(...args);
    shouldWait = true;
    setTimeout(() => {
      shouldWait = false;
    }, delay);
  };
}

let purchasesInstance: any = null;

export const configureRevenueCat = (user) => {
  if (purchasesInstance) return purchasesInstance;

  try {
    // const user = getUserFromLocalStorage();
    const appUserId = user?._id; // Replace with your authentication logic
    if (!appUserId) {
      throw new Error("User ID is required for RevenueCat configuration.");
    }
    purchasesInstance = Purchases.configure(
      REVENUECAT_BILLING_PUBLIC_API_KEY,
      appUserId
    );
    return purchasesInstance;
  } catch (error) {
    console.error("Error configuring RevenueCat:", error);
    throw error;
  }
};

export const fetchCustomerInfo = async () => {
  try {
    const customerInfo = await Purchases.getSharedInstance().getCustomerInfo();

    // Save customer info to localStorage
    localStorage.setItem("customerInfo", JSON.stringify(customerInfo));
    return customerInfo;
  } catch (error) {
    throw error;
  }
};

export const getCustomerInfoFromLocalStorage = () => {
  const customerInfoJson = localStorage.getItem("customerInfo");
  return customerInfoJson ? JSON.parse(customerInfoJson) : null;
};

const showPremiumAlert = (navigate) => {
  store.dispatch(openDialog());
};

export const calculateCryptoChange = (
  currentPrice?: number,
  percentChange?: number
) => {
  if (currentPrice == null || percentChange == null) {
    return { changeAmount: 0, changePercentage: 0 };
  }

  const changeAmount = (currentPrice * percentChange) / 100;
  return { changeAmount, changePercentage: percentChange };
};

export const renderPaymentIcon = (method: any, size: number = 38) => {
  const s = Number(size) || 38;
  switch (method?.type) {
    case 'shareSellDown':
      return <ShareSellDownIcon width={s} height={s} />;

    case 'creditCard':
      switch (method.cardType) {
        case 'Visa':
          return <VisaIcon style={{ marginBottom: size ? '10px' : '0px' }} height={s} />;
        case 'MasterCard':
          return <MastercardIcon height={s} />;
        case 'Amex':
        case 'American Express':
          return (
            <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} fill="none">
              <rect width={s} height={s} rx={Math.max(4, Math.round(s / 8))} fill="#fff" />
              <text x="50%" y="55%" textAnchor="middle" fill="#2E77BB"
                fontSize={Math.max(8, Math.round(s / 3))} fontWeight="bold" fontFamily="Arial">AMEX</text>
            </svg>
          );
        default:
          return (
            <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} fill="none">
              <rect width={s} height={s} rx={Math.max(4, Math.round(s / 8))} fill="#fff" />
              <text x="50%" y="55%" textAnchor="middle" fill="#888"
                fontSize={Math.max(8, Math.round(s / 3))} fontWeight="bold" fontFamily="Arial">CARD</text>
            </svg>
          );
      }

    case 'bankAccount':
      return <BankIcon width={s} height={s} color="#ffff" />;
    case 'wallet':
      return (
        <img
          src={WalletIcon}
          alt="Wallet"
          width={s}
          height={s}
          style={{ objectFit: 'contain', marginTop: '-5px' }}
        />
      );

    default:
      return null;
  }
};

export const getPaymentDisplayDetails = (
  paymentMethodId,
  paymentMethods: any[],
  size: number = 28
) => {
  const method = paymentMethods?.find((m) => m.id === paymentMethodId);

  return {
    valid: !!method,
    icon: method ? renderPaymentIcon(method, size) : null,
    label: method
      ? method.type === "shareSellDown"
        ? method.displayName
        : `${method.displayName} ${method.displayNumber}`
      : ""
  };
};

export const formatCurrencySigned = (value: number): string => {
  if (value === null || value === undefined || isNaN(value)) return "$0.00";

  const absValue = Math.abs(value);
  let formatted: string;

  if (absValue === 0) {
    formatted = "0.00";
  } else if (absValue >= 1) {
    // Values >= 1: Show 2 decimals, remove trailing zeros
    formatted = absValue.toFixed(2).replace(/\.?0+$/, "");
  } else if (absValue >= 0.0001) {
    // Small values (0.0001 to 0.9999): Show up to 6 decimals, remove trailing zeros
    formatted = absValue.toFixed(6).replace(/\.?0+$/, "");
  } else {
    // Very small values: Show up to 8 decimals for precision
    formatted = absValue.toFixed(8).replace(/\.?0+$/, "");
  }

  return value < 0 ? `-$${formatted}` : `$${formatted}`;
};

export const formatPercentSigned = (value: number): string => {
  if (value === null || value === undefined || isNaN(value)) return "0.00%";

  const abs = Math.abs(value).toFixed(2);

  return value < 0 ? `-${abs}%` : `${abs}%`;
};

export const formatPrice = (price: any): string => {
  if (price === null || price === undefined || isNaN(price)) {
    return "0.00";
  }

  const value = Number(price);
  const absValue = Math.abs(value);

  if (absValue >= 1) {
    // Always show exactly 2 decimals
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  if (absValue >= 0.0001) {
    // Small values: up to 6 decimals, trim trailing zeros
    return value.toFixed(6).replace(/\.?0+$/, "");
  }

  // Very tiny values
  return value.toFixed(8).replace(/\.?0+$/, "");
};


export function formatNumber(num) {
  if (num >= 1_000_000_000_000) {
    return (num / 1_000_000_000_000)?.toFixed(4) + "T";
  }
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000)?.toFixed(4) + "B";
  }
  if (num >= 1_000_000) {
    return (num / 1_000_000)?.toFixed(4) + "M";
  }
  return num?.toString();
}

export const renderPaymentMethodDetails = (paymentMethodId: string, paymentMethods: any[]) => {
  const { valid, icon, label } = getPaymentDisplayDetails(
    paymentMethodId,
    paymentMethods,
    28
  );

  if (!valid) {
    return (
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
        <Typography style={{ color: "white" }}>No method</Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
      {icon}
      <Typography style={{ color: "white" }}>{label}</Typography>
    </Box>
  );
};

export const getUserTimezone = (): string => {
  try {
    const offset = moment().utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? '+' : '-';
    return `UTC${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  } catch (e) {
    console.warn('Could not determine user timezone, falling back to UTC', e);
    return 'UTC';
  }
};

const normalizeInput = (input: any): moment.Moment | null => {
  if (input === null || input === undefined || input === '' || input === 0 || input === '0') {
    return null;
  }

  // Handle Date objects
  if (input instanceof Date) {
    return moment(input).isValid() ? moment(input) : null;
  }

  // Handle moment objects
  if (moment.isMoment(input)) {
    return input.isValid() ? input : null;
  }

  // Handle ISO date strings (YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss, etc.)
  if (typeof input === 'string') {
    const m = moment(input);
    if (m.isValid()) {
      return m;
    }
  }

  // Handle numeric timestamps
  const timestamp = Number(input);
  if (!isNaN(timestamp) && timestamp > 0) {
    // Auto-detect if timestamp is in seconds or milliseconds
    // If less than year 2100 in milliseconds, it's likely in seconds
    const ts = timestamp < 10000000000 ? timestamp * 1000 : timestamp;
    const m = moment(ts);
    return m.isValid() ? m : null;
  }

  return null;
};

export const formatTimestampToUserTimezone = (
  input: any,
  format: DateFormat = 'SHORT_MONTH',
  showMeridiem: boolean = true
): FormattedDateTime => {
  const tz = getUserTimezone();

  const m = normalizeInput(input);

  // Handle invalid input
  if (!m) {
    return {
      date: '--/--/----',
      time: '--:--:--',
      timezone: tz,
      full: '--/--/---- --:--:--',
      iso: ''
    };
  }

  // Use local time
  const momentInTz = m.local();

  // Dynamic time formats
  const timeFormat = showMeridiem ? 'h:mm:ss A' : 'h:mm:ss';
  const shortTimeFormat = showMeridiem ? 'h:mm A' : 'h:mm';

  let date: string;
  let time: string;
  let full: string;

  switch (format) {
    case 'LONG_MONTH':
      date = momentInTz.format('MMMM D, YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`MMMM D, YYYY ${timeFormat}`);
      break;

    case 'MM/DD/YYYY':
      date = momentInTz.format('MM/DD/YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`MM/DD/YYYY ${timeFormat}`);
      break;

    case 'DD/MM/YYYY':
      date = momentInTz.format('DD/MM/YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`DD/MM/YYYY ${timeFormat}`);
      break;

    case 'YYYY-MM-DD':
    case 'ISO':
      date = momentInTz.format('YYYY-MM-DD');
      time = momentInTz.format(showMeridiem ? 'HH:mm:ss A' : 'HH:mm:ss');
      full = momentInTz.format(
        showMeridiem
          ? 'YYYY-MM-DD HH:mm:ss A'
          : 'YYYY-MM-DD HH:mm:ss'
      );
      break;

    case 'FULL':
      date = momentInTz.format('MMMM D, YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`MMMM D, YYYY ${timeFormat}`);
      break;

    case 'DATETIME_SHORT':
      date = momentInTz.format('MMM D, YYYY');
      time = momentInTz.format(shortTimeFormat);
      full = momentInTz.format(`MMM D, YYYY ${shortTimeFormat}`);
      break;

    case 'DATETIME_LONG':
      date = momentInTz.format('MMMM D, YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`MMMM D, YYYY ${timeFormat}`);
      break;

    case 'SHORT_MONTH':
    default:
      date = momentInTz.format('MMM D, YYYY');
      time = momentInTz.format(timeFormat);
      full = momentInTz.format(`MMM D, YYYY ${timeFormat}`);
  }

  return {
    date,
    time,
    timezone: tz,
    full,
    iso: momentInTz.toISOString()
  };
};

export const getWeekdayFromTimestamp = (input: any): string => {
  const m = normalizeInput(input);
  if (!m) return '--';
  return m.format('dddd');
};

export const getDateFromTimestamp = (
  input: any,
  format: DateFormat = 'SHORT_MONTH'
): string => {
  const result = formatTimestampToUserTimezone(input, format);
  return result.date;
};

export const getDateTimeFromTimestamp = (
  input: any,
  showMeridiem: boolean = true
) => {
  const result = formatTimestampToUserTimezone(
    input,
    'SHORT_MONTH',
    showMeridiem
  );

  return {
    date: result.date,
    time: result.time
  };
};

export const getRelativeTime = (input: any): string => {
  const m = normalizeInput(input);
  if (!m) return 'Invalid date';

  return m.fromNow();
};

export const isToday = (input: any): boolean => {
  const m = normalizeInput(input);
  if (!m) return false;

  return m.isSame(moment(), 'day');
};

export const isPast = (input: any): boolean => {
  const m = normalizeInput(input);
  if (!m) return false;

  return m.isBefore(moment());
};

export const isFuture = (input: any): boolean => {
  const m = normalizeInput(input);
  if (!m) return false;

  return m.isAfter(moment());
};

export const getDateDifference = (
  date1: any,
  date2: any,
  unit: moment.unitOfTime.Diff = 'days'
): number | null => {
  const m1 = normalizeInput(date1);
  const m2 = normalizeInput(date2);

  if (!m1 || !m2) return null;

  return m1.diff(m2, unit);
};

export default showPremiumAlert;
